// extracted by mini-css-extract-plugin
module.exports = {"abtn_box":"Abutton_abtn_box__2cbgz","btn_diamond":"Abutton_btn_diamond__1BJPn","btn_bagcolor":"Abutton_btn_bagcolor__1xo04"};